import { showNotification } from '../../NotificationBanner/showNotification';

export const showTerritoryErrorNotification = () => {
  showNotification({
    type: 'error',
    message: 'There was a problem with launching your Territory.',
  });
};
